import { Injectable } from '@angular/core';
import { environment } from '@ui-nuvertos/shared';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  private readonly secretKey: string;

  constructor() {
    // Get encryption key from environment or secure key management
    this.secretKey = environment.encryptionKey || this.generateSecureKey();
  }

  private generateSecureKey(): string {
    // Generate a secure key if none provided (for development only)
    return CryptoJS.lib.WordArray.random(256/8).toString();
  }

  encrypt(data: any): string {
    try {
      const jsonString = JSON.stringify(data);
      return CryptoJS.AES.encrypt(jsonString, this.secretKey).toString();
    } catch (error) {
      console.error('Encryption failed:', error);
      throw new Error('Failed to encrypt data');
    }
  }

  decrypt(cipherText: string): any {
    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, this.secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      
      if (!decryptedData) {
        throw new Error('Invalid encrypted data');
      }
      
      return JSON.parse(decryptedData);
    } catch (error) {
      console.error('Decryption failed:', error);
      throw new Error('Failed to decrypt data');
    }
  }

  // Method to rotate encryption keys
  rotateKey(newKey: string): void {
    // this.secretKey = newKey;
  }
}
